class Mask {
	constructor(id, styles, click, attachTo) {
		this.data = {
			id: id,
			styles: styles,
			element: null,
			shown: false,
			onClick: click
		};

		this.attachTo = document.querySelector(attachTo);
		if (!this.attachTo) {
			this.attachTo = document.body;
		}

		this.add();

		jQuery(document.body).on('click', `#mask-${this.data.id}`, () => {
			this.click();
		});
	}

	add() {
		this.attachTo.insertAdjacentHTML('beforeend', `<div id="mask-${this.data.id}" class="mask-element"></div>`);
		this.data.element = document.getElementById(`mask-${this.data.id}`);

		this.data.element.style.position = 'fixed';
		this.data.element.style.top = 0;
		this.data.element.style.left = 0;
		this.data.element.style.right = 0;
		this.data.element.style.bottom = 0;
		this.data.element.style.display = 'none';
		this.data.element.style.opacity = '0';

		for (let style of Object.keys(this.data.styles)) {
			this.data.element.style[style] = this.data.styles[style];
		}
	}

	show(complete) {
		gsap.to(this.data.element, {
			opacity: 1,
			duration: 0.3,
			onStart: () => {
				this.data.element.style.display = 'block';
			},
			onComplete: () => {
				this.data.shown = true;
				if (complete)
					complete();
			}
		});
	}

	hide(complete) {
		gsap.to(this.data.element, {
			opacity: 0,
			display: "none",
			duration: 0.3,
			onComplete: () => {
				this.data.shown = true;
				if (complete)
					complete();
			}
		});
	}

	click() {
		if (this.data.shown && this.data.onClick) {
			this.data.onClick();
		}
	}
}


export default Mask;